var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.tableData,"headers":_vm.tableDataHeaders},scopedSlots:_vm._u([_vm._l((_vm.tableDataHeaders),function(header){return {key:`item.${header.value}`,fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.getTextForItemAndHeader(item, header))+" ")]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }